import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, TextField, Typography } from '@material-ui/core'
import { useFormQuesitos } from './hooks/useFormQuesitos'
import { useStyles } from './FormQuesitos.styles'

export const FormQuesitos = (props) => {
  const { idExameRealizado, setRespostasComponentePai } = props
  const classes = useStyles()

  const {
    respostasQuesitos,
    processandoRespostas,
    handleChangeRespostasQuesitos,
  } = useFormQuesitos(idExameRealizado, setRespostasComponentePai)

  return (
    <div className={classes.root}>
      {processandoRespostas ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container>
          {respostasQuesitos?.length ? (
            respostasQuesitos.map((respostaQuesito, index) => (
              <Grid key={respostaQuesito.id} item container className={classes.itemQuesito}>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography className={classes.perguntaQuesito}>
                    {index + 1}. {respostaQuesito.quesito?.quesito?.toUpperCase()}
                  </Typography>
                </Grid>
                <Grid item md={12} sm={12} xs={12} className={classes.inputResposta}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    value={respostaQuesito.resposta || ''}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name={`resposta_${respostaQuesito.id}`}
                    onChange={(e) => {
                      handleChangeRespostasQuesitos(e.target.value, respostaQuesito.id)
                    }}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item md={12} sm={12} xs={12} style={{ padding: '20px', textAlign: 'center' }}>
              <Typography variant="body2">
                NÃO FORAM CADASTRADOS QUESITOS PARA ESTE EXAME
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  )
}

FormQuesitos.propTypes = {
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setRespostasComponentePai: PropTypes.func.isRequired,
}
